import type { Maybe, MntnSettings } from '@types/gatsby-types';
import { graphql, useStaticQuery } from 'gatsby';

const query = graphql`
    query MntnAdvertiserIdQuery {
        settings {
            mntn {
                enabled
                advertiserId
            }
        }
    }
`;

type MntnAdvertiserIdQuery = {
    settings: Maybe<{
        mntn: Maybe<Pick<MntnSettings, 'advertiserId'>>;
    }>;
};

type UseMntnAdvertiserId = {
    enabled: boolean;
    advertiserId: string | null;
};

export default function useMntnAdvertiserId(): UseMntnAdvertiserId {
    const { settings } = useStaticQuery<MntnAdvertiserIdQuery>(query);

    return {
        enabled: !!settings?.mntn?.enabled,
        advertiserId: settings?.mntn?.advertiserId ?? null,
    };
}
